import React from 'react';
import { YearView } from '@bryntum/calendar';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumYearView extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        const className = `b-react-year-view-container`;
        return (React.createElement("div", { className: className, ref: (element) => (this.element = element) }));
    }
}
BryntumYearView.instanceClass = YearView;
BryntumYearView.instanceName = 'YearView';
BryntumYearView.configNames = [
    'activationKey',
    'adopt',
    'align',
    'anchor',
    'ariaDescription',
    'ariaLabel',
    'bbar',
    'bodyCls',
    'bubbleEvents',
    'callOnFunctions',
    'centered',
    'collapsible',
    'config',
    'constrainTo',
    'contentElementCls',
    'date',
    'dayCellNameFormat',
    'dayCellRenderer',
    'defaultBindProperty',
    'defaultFocus',
    'defaults',
    'descriptionRenderer',
    'dock',
    'draggable',
    'drawer',
    'elementAttributes',
    'emptyCellRenderer',
    'eventFilter',
    'eventHeaderRenderer',
    'eventHeight',
    'eventRenderer',
    'eventSorter',
    'floating',
    'footer',
    'getPrimaryResource',
    'header',
    'hideAnimation',
    'hideWhenEmpty',
    'ignoreParentReadOnly',
    'itemCls',
    'lazyItems',
    'listeners',
    'localeClass',
    'localizable',
    'localizableProperties',
    'maskDefaults',
    'masked',
    'monitorResize',
    'namedItems',
    'nonWorkingDays',
    'overflowButtonRenderer',
    'overflowPopup',
    'overflowPopupTrigger',
    'owner',
    'positioned',
    'preventTooltipOnTouch',
    'relayStoreEvents',
    'resourceImagePath',
    'responsive',
    'responsiveRoot',
    'responsiveState',
    'responsiveTarget',
    'ripple',
    'rootElement',
    'scrollAction',
    'selectorButton',
    'selectorMenuItem',
    'shortEventCls',
    'shortEventDuration',
    'showAnimation',
    'showBullet',
    'showResourceAvatars',
    'showTooltipWhenDisabled',
    'sixWeeks',
    'stateful',
    'statefulEvents',
    'stateId',
    'stateProvider',
    'strips',
    'tab',
    'tabBarItems',
    'tag',
    'tbar',
    'textAlign',
    'timeFormat',
    'trapFocus',
    'type',
    'ui',
    'weekStartDay',
    'weight',
    'year'
];
BryntumYearView.propertyConfigNames = [
    'alignSelf',
    'allowDragCreate',
    'allowDragMove',
    'allowDragResize',
    'animateTimeShift',
    'appendTo',
    'ariaLive',
    'autoCreate',
    'cls',
    'collapsed',
    'dataset',
    'dateFormat',
    'dateSeparator',
    'defaultScrollOptions',
    'descriptionFormat',
    'disabled',
    'dragUnit',
    'eventCountTip',
    'eventDots',
    'eventSpacing',
    'extendAllDayEndDay',
    'extraData',
    'filterEventResources',
    'flex',
    'height',
    'hidden',
    'hideNonWorkingDays',
    'id',
    'insertBefore',
    'insertFirst',
    'items',
    'keyMap',
    'layout',
    'layoutStyle',
    'margin',
    'maxDate',
    'maxDots',
    'maxHeight',
    'maximizeOnMobile',
    'maxWidth',
    'minDate',
    'minHeight',
    'minWidth',
    'onBeforeAutoCreate',
    'onBeforeChangeDate',
    'onBeforeDestroy',
    'onBeforeHide',
    'onBeforeResponsiveStateChange',
    'onBeforeSetRecord',
    'onBeforeShow',
    'onBeforeShowOverflowPopup',
    'onBeforeStateApply',
    'onBeforeStateSave',
    'onCatchAll',
    'onCellMapPopulated',
    'onCollapse',
    'onDayCellPopulated',
    'onDestroy',
    'onDirtyStateChange',
    'onEmptyCellClick',
    'onEventAutoCreated',
    'onEventPropagate',
    'onExpand',
    'onFocusIn',
    'onFocusOut',
    'onHide',
    'onPaint',
    'onReadOnly',
    'onRecompose',
    'onRefresh',
    'onResize',
    'onResponsiveStateChange',
    'onShow',
    'onShowOverflowPopup',
    'onToolClick',
    'pastEventCls',
    'readOnly',
    'rtl',
    'scrollable',
    'shortDateFormat',
    'shortDateTimeFormat',
    'showEvents',
    'stackMultiDayEvents',
    'strictRecordMapping',
    'syncCalendarDate',
    'syncViewDate',
    'title',
    'tools',
    'tooltip',
    'width',
    'x',
    'y'
];
BryntumYearView.propertyNames = [
    'anchorSize',
    'dayCellCls',
    'firstVisibleCell',
    'firstVisibleDate',
    'focusVisible',
    'hasChanges',
    'isSettingValues',
    'isValid',
    'lastVisibleCell',
    'lastVisibleDate',
    'parent',
    'record',
    'state',
    'values'
];
//# sourceMappingURL=BryntumYearView.js.map